import React, { useState } from 'react';
import { Box, Chip, Stack, Typography } from '@mui/joy';
import { motion, AnimatePresence } from 'framer-motion';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import ToolCallMessage from './ToolCallMessage';
import ToolOutputMessage from './ToolOutputMessage';

const ToolCallGroup = ({ messages }) => {
  const [expanded, setExpanded] = useState(false);
  const lastMsg = messages[messages.length - 1];
  const hiddenCount = messages.length - 1;

  return (
    <Box sx={{ mb: 2, pl: 7 }}>
      <AnimatePresence mode="wait">
        {!expanded ? (
          <motion.div
            key="collapsed"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.2 }}
          >
            <Stack direction="row" alignItems="flex-start" gap={1} flexWrap="wrap">
              {lastMsg.role === 'tool_call' ? (
                <ToolCallMessage message={lastMsg} nested />
              ) : (
                <ToolOutputMessage message={lastMsg} nested />
              )}
              {hiddenCount > 0 && (
                <Chip
                  size="sm"
                  variant="soft"
                  color="neutral"
                  onClick={() => setExpanded(true)}
                  startDecorator={<KeyboardArrowRightIcon sx={{ fontSize: 14 }} />}
                  sx={{ cursor: 'pointer', alignSelf: 'center', fontSize: '0.7rem' }}
                >
                  {hiddenCount} more
                </Chip>
              )}
            </Stack>
          </motion.div>
        ) : (
          <motion.div
            key="expanded"
            initial={{ opacity: 0, height: 0 }}
            animate={{ opacity: 1, height: 'auto' }}
            exit={{ opacity: 0, height: 0 }}
            transition={{ duration: 0.2 }}
          >
            <Stack
              direction="row"
              alignItems="center"
              gap={0.5}
              onClick={() => setExpanded(false)}
              sx={{ cursor: 'pointer', mb: 1, display: 'inline-flex' }}
            >
              <KeyboardArrowDownIcon sx={{ fontSize: 16, color: 'text.tertiary' }} />
              <Typography level="body-xs" color="neutral">
                {messages.length} tool action{messages.length !== 1 ? 's' : ''}
              </Typography>
            </Stack>
            <Stack gap={1}>
              {messages.map((msg, idx) => (
                <Box key={msg.id || idx}>
                  {msg.role === 'tool_call' ? (
                    <ToolCallMessage message={msg} nested />
                  ) : (
                    <ToolOutputMessage message={msg} nested />
                  )}
                </Box>
              ))}
            </Stack>
          </motion.div>
        )}
      </AnimatePresence>
    </Box>
  );
};

export default ToolCallGroup;
